export default "/react/logoStoreido-bf07f117.png";